(() => {
    const heroes = document.querySelectorAll("[data-hero]");
    if (!heroes.length) return;

    const mobile = window.matchMedia("(max-width: 749px)").matches;

    // Returns a function that swaps the image for the video, or null if this banner has no video
    function prepareHero(hero) {
        if (hero.dataset.videoInit) return null; // script can be included more than once
        hero.dataset.videoInit = "true";

        const media = hero.querySelector("[data-hero-media]");
        const data = hero.querySelector("[data-desktop-video]");
        if (!media || !data) return null;

        const src = mobile ? data.dataset.mobileVideo : data.dataset.desktopVideo;
        if (!src) return null;

        return () => {
            const heroImg = media.querySelector("img");
            const poster = (heroImg && heroImg.currentSrc) ||
                (mobile ? data.dataset.mobilePoster : data.dataset.desktopPoster);

            const video = document.createElement("video");
            video.className = "img-vid-cover";
            video.setAttribute("aria-hidden", "true");
            video.autoplay = true;
            video.muted = true;
            video.loop = true;
            video.playsInline = true;
            video.preload = "auto";
            video.poster = poster;

            const source = document.createElement("source");
            source.src = src;
            source.type = "video/mp4";
            video.appendChild(source);

            video.addEventListener("loadeddata", () => media.replaceWith(video), { once: true });
            video.load();
        };
    }

    function start() {
        const observer = "IntersectionObserver" in window
            ? new IntersectionObserver((entries, obs) => {
                entries.forEach(entry => {
                    if (!entry.isIntersecting) return;
                    obs.unobserve(entry.target);
                    entry.target._loadVideo();
                });
            }, { rootMargin: "300px 0px" })
            : null;

        heroes.forEach((hero, i) => {
            const loadVideo = prepareHero(hero);
            if (!loadVideo) return;

            if (i === 0 || !observer) {
                // First banner: after page load + idle
                setTimeout(() => {
                    if ("requestIdleCallback" in window) {
                        requestIdleCallback(loadVideo, { timeout: 3000 });
                    } else {
                        loadVideo();
                    }
                }, 1000);
            } else {
                // Lower banners: only when user scrolls near them
                hero._loadVideo = loadVideo;
                observer.observe(hero);
            }
        });
    }

    if (document.readyState === "complete") {
        start();
    } else {
        window.addEventListener("load", start, { once: true });
    }
})();